module.exports = __webpack_public_path__ + "img/call.386d627e.svg";